import { shieldFromPhaser } from './uiShield.js';
import { isTouchDevice } from './isTouchDevice.js';
import { iconHtml } from './iconHtml.mjs';

// The „turn around" button. A U-turn used to be a TAP of the opposite arrow at a standstill
// — a gesture no eight-year-old ever found by accident, and one that fought the same key
// reverse is on. So it became a thing you can SEE: a DOM button in the bottom-right corner,
// on top of the canvas, in the same styling family as the mobile action button (which it
// stacks above on touch, clearing the action ✕/anuluj pair at 24 px and 100 px).
//
//   const btn = new UturnButton(scene, { onPress: () => car.uturn() });
//   btn.setVisible(car.canUturn);   // polled from CarController.update()
//   btn.destroy();                  // …or let the scene's shutdown do it
//
// Only ever shown while the car is standing still: turning round at speed is not a thing,
// and a button that refuses is worse than no button.

export const UTURN_LABEL = 'Zawróć {back}';

export class UturnButton {
  constructor(scene, { onPress = null } = {}) {
    this.scene = scene;
    const el = document.createElement('button');
    el.id = 'uturn-btn';
    el.innerHTML = iconHtml(UTURN_LABEL);
    el.style.cssText = [
      'position:fixed', 'right:24px', `bottom:${isTouchDevice() ? '176px' : '24px'}`,
      'z-index:1500', 'min-width:132px', 'height:56px',
      'border:none', 'border-radius:16px', 'background:#ffd166', 'color:#000',
      'font:bold 20px system-ui', 'box-shadow:0 2px 6px #0006',
      'cursor:pointer', 'touch-action:none', 'display:none',
    ].join(';');
    el.addEventListener('click', (e) => { e.preventDefault(); onPress?.(); });
    document.body.appendChild(el);
    shieldFromPhaser(el);

    this.el = el;
    this._visible = false;
    this._onShutdown = () => this.destroy();
    scene.events.once('shutdown', this._onShutdown);
  }

  setVisible(on) {
    const want = !!on;
    if (want === this._visible || !this.el) return;
    this._visible = want;
    this.el.style.display = want ? 'block' : 'none';
  }

  destroy() {
    this.scene?.events?.off('shutdown', this._onShutdown);
    this.el?.remove();
    this.el = null;
  }
}
